import {Component, OnInit} from '@angular/core';
import {UsuarioService} from "../usuario/usuario.service";


import {Usuario} from "../usuario/usuario";
import {AppComponent} from "../app.component";

@Component({
    selector: 'app-usuario-list',
    templateUrl: './usuario-list.component.html',
    styleUrls: ['./usuario-list.component.css'],
    providers: [UsuarioService]
})
export class UsuarioListComponent extends AppComponent implements OnInit {

    usuarios:Usuario[];
    dados:any;
    perfis:any;
    value:string;

    ngOnInit() {
		if (!this.isAdmin())
			this.router.navigateByUrl('inicio');
		else {
			this.spinnerService.show();
			this.usuarioService.get().then( (resp)=> {
				this.dados=(resp); 
				this.spinnerService.hide();
			});
			this.perfilService.get().then((resp)=> this.perfis=(resp));
		}
	}

    save_perfil(user_id,perfil_id){
        let data = new Object();
        data['user_id'] = user_id;
        data['perfilsys_id'] = perfil_id;
        this.usuarioService.setPerfil(data);
    }

    search() {
        let data = new Object();
        data['value'] = this.value;
        this.usuarioService.search(data).then((resp) => this.dados = (resp));
    }

    save_deactive(user_id,desativado){
        let data = new Object();
        data['user_id'] = user_id;
        data['desativado'] = desativado;
        console.log(data['desativado']);
        this.usuarioService.setDesativado(data);
    }

}



// WEBPACK FOOTER //
// ./src/app/usuario-list/usuario-list.component.ts